import { useEffect, useState } from 'react';
import {
  isTopmostModal,
  registerModal,
  subscribeModalStack,
  unregisterModal,
} from '../utils/modalStack';

export default function useModalStackRegistration(active = true) {
  const [isTopmost, setIsTopmost] = useState(false);

  useEffect(() => {
    if (!active) {
      setIsTopmost(false);
      return undefined;
    }

    const modalId = registerModal();
    const syncTopmost = () => setIsTopmost(isTopmostModal(modalId));
    const unsubscribe = subscribeModalStack(syncTopmost);
    syncTopmost();

    return () => {
      unsubscribe();
      unregisterModal(modalId);
    };
  }, [active]);

  return isTopmost;
}
